module.exports = __webpack_public_path__ + "img/logo-horizontal-dark-wt-jili.72dd2f90.png";